export default {
      id: "pie-usage",
      viewBox: "0 0 20 22",
      url: "/" + "images/icons.3.109.2.svg#pie-usage",
      toString: function () {
        return this.url;
      }
    }